import React from "react";
import { PlayCircleOutline } from "@material-ui/icons";
import './VideoPause.css'
const VideoPause = () => {
    return (<div className="VideoPause">
    <div className="playOrPause" >
        <PlayCircleOutline />
    </div>
</div>)
}

export default VideoPause